import { CandidateBuilder } from '../candidates.types';

export const doNotHireCandidate = (builder: CandidateBuilder) =>
  builder.mutation<any, any>({
    query: ({ candidateId, doNotHire }) => ({
      url: `/candidates/do-not-hire/${candidateId}`,
      method: 'PATCH',
      body: { DoNotHire: doNotHire },
    }),
    invalidatesTags: ({ candidateId }) => [
      {
        type: 'Candidate',
        Id: candidateId,
      },
    ],
  });
